import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function ClientDetailsPage() {
  const [data, setData] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/contract-summary`)
      .then(res => res.json())
      .then(setData);
  }, []);

  // Group and aggregate by lexiFi_link
  const grouped = {};
  data.forEach(row => {
    const key = row.lexiFi_link || 'unknown';
    if (!grouped[key]) {
      grouped[key] = {
        total: 0,
        imported: 0,
        verifiedNotImported: 0,
        notVerifiedNotImported: 0,
        others: 0
      };
    }
    grouped[key].total++;
    if (row.import_status === 'imported') {
      grouped[key].imported++;
    } else if (row.import_status !== 'imported' && row.status === 'verified') {
      grouped[key].verifiedNotImported++;
    } else if (row.import_status !== 'imported' && row.status !== 'verified') {
      grouped[key].notVerifiedNotImported++;
    } else {
      grouped[key].others++;
    }
  });

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Client Details</Typography>
      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>Contract Summary by LexiFi Link</Typography>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>LexiFi Link</th>
                <th>Total Trx</th>
                <th>Imported</th>
                <th>Verified & Not Imported</th>
                <th>Not Verified & Not Imported</th>
                <th>Others</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(grouped).map(([lexiFi_link, vals]) => (
                <tr key={lexiFi_link}>
                  <td>{lexiFi_link}</td>
                  <td>{vals.total}</td>
                  <td>{vals.imported}</td>
                  <td>{vals.verifiedNotImported}</td>
                  <td>{vals.notVerifiedNotImported}</td>
                  <td>{vals.others}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <Box sx={{ mt: 4 }}>
            <Typography variant="subtitle1" gutterBottom>Waterfall Chart (Stacked Bar) by LexiFi Link</Typography>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={Object.entries(grouped).map(([lexiFi_link, vals]) => ({
                  lexiFi_link,
                  Imported: vals.imported,
                  VerifiedNotImported: vals.verifiedNotImported,
                  NotVerifiedNotImported: vals.notVerifiedNotImported,
                  Others: vals.others
                }))}
                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
              >
                <XAxis dataKey="lexiFi_link" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Imported" stackId="a" fill="#43a047" />
                <Bar dataKey="VerifiedNotImported" stackId="a" fill="#1976d2" />
                <Bar dataKey="NotVerifiedNotImported" stackId="a" fill="#e53935" />
                <Bar dataKey="Others" stackId="a" fill="#757575" />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
